<template>
    <AisRefinementList
        :attribute="name"
        show-more
        :limit="4"
        :transform-items="transformLinks"
        :sort-by="sortBy"
    >
        <template v-slot="{ items, isShowingMore, canToggleShowMore, refine, toggleShowMore }">
            <div class="filter-places">
                <div class="title" v-if="title">{{ title }}</div>
                <ul>
                    <template v-for="item in items">
                        <li class="checkbox" v-if="item.data" :key="item.value">
                            <a
                                href="javascript:"
                                @click.prevent="refine(item.value)"
                            >
                                <span>
                                    {{ item.data.title }}
                                </span>
                            </a>
                        </li>
                    </template>
                </ul>
                <a
                    href="javascript:"
                    class="more"
                    v-if="props.showMore && canToggleShowMore"
                    @click="toggleShowMore"
                >
                    {{ !isShowingMore ? '+ Vis flere' : '- Vis mindre' }}
                </a>
            </div>
        </template>
    </AisRefinementList>
</template>
<script setup lang="ts">
    import { ref } from 'vue'

    const props = defineProps({
        name: {
            required: true,
            type: String,
        },
        title: {
            required: true,
            type: String,
        },
        sortBy: {
            required: false,
            type: Array,
        },
        showMore: {
            required: false,
            type: Boolean,
        },
        entry: {
            required: true,
        },
        pageType: {
            required: true,
        },
        countries: {
            required: false,
        },
        travelType: {
            required: false,
        },
    })

    const params = ref(window.location.search)
    const buildUrl = (url) => url + params.value

    const transformLinks = (items, { results }) => {
        return items.map((item) => ({
            ...item,
            data: props.countries.find((c) => c.slug === item.value),
        }))
    }
</script>
